import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M77.2107 43.3552C77.2107 43.3552 59.3807 34.0452 55.3307 29.3052C50.8307 24.0452 51.0307 1.40527 51.0307 1.40527H38.6107C38.6107 1.40527 38.9207 24.1552 34.3107 29.3052C29.4207 34.7652 12.2607 43.0153 12.2607 43.0153C18.4507 57.5953 35.2807 59.0153 44.8207 59.0153C54.3607 59.0153 71.0207 57.9352 77.2107 43.3552Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M76.5104 42.1453C76.5104 42.1453 65.5904 55.2052 44.7304 55.2052C23.8704 55.2052 12.9504 42.1453 12.9504 42.1453C8.28039 44.3453 4.78039 47.7652 3.07039 58.6752C1.41039 69.2752 1.15039 71.6052 1.15039 71.6052H88.3004C88.3004 71.6052 88.0104 69.2352 86.3804 58.6752C84.6604 47.4252 81.1804 44.3553 76.5104 42.1453Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M10.2607 43.6353C8.95067 45.4553 8.18066 47.6852 8.18066 50.0952C8.18066 56.2052 13.1407 61.1652 19.2507 61.1652C21.4407 61.1652 23.4707 60.5252 25.1907 59.4252C26.3007 64.3652 30.7107 68.0452 35.9807 68.0452C39.5307 68.0452 42.6907 66.3653 44.7107 63.7653C46.7307 66.3653 49.8907 68.0452 53.4407 68.0452C58.6807 68.0452 63.0607 64.4053 64.2107 59.5153C65.9007 60.5553 67.8707 61.1652 70.0007 61.1652C76.1107 61.1652 81.0707 56.2052 81.0707 50.0952C81.0707 47.6552 80.2807 45.3952 78.9407 43.5652"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="44.7377"
          y1="25.7973"
          x2="44.7377"
          y2="9.06617"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
